exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-222a1cd6] .el-checkbox-group .el-checkbox,[data-v-222a1cd6] .el-radio-group .el-radio{display:block;margin-top:10px}.right-answer[data-v-222a1cd6]{color:#3cc35e;background-color:rgba(184,255,202,.5);border-color:#3cc35e!important}.wrong-answer[data-v-222a1cd6]{color:#ff5047;background-color:rgba(255,202,199,.5);border-color:#ff5047!important}", ""]);

// exports
